var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 6.223 9.023 4a.833.833 0 0 1 .837.837c0 .612-.334 1-.522 1.17a.45.45 0 0 0 .278.782l2.521.14a.83.83 0 0 1 .641.271c.155.17.24.398.218.639l-.912 4.29a.835.835 0 0 1-.713.655l-4.571.004V6.223Zm-1 .765-1.8.36.418 5.442L5.8 12.79v-5.8Zm4.451-3.38a1.737 1.737 0 0 0-1.497-.488.45.45 0 0 0-.251.127L5.649 6.1l-2.217.443a.45.45 0 0 0-.36.476l.48 6.255a.45.45 0 0 0 .45.416l7.395-.007a1.737 1.737 0 0 0 1.566-1.367l.919-4.315a1.734 1.734 0 0 0-.44-1.41 1.73 1.73 0 0 0-1.267-.562l-1.673-.093c.148-.293.258-.66.258-1.1 0-.48-.195-.915-.509-1.229Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.4ea3f384c96962fb8287dca232f4b4c4.svg";
export { ForwardRef as ReactComponent };